module.exports = __webpack_public_path__ + "img/fondo-banner-principal.d2033746.svg";